import OrderingTableList from "../../views/OrderingTable/Board/OrderingTableList.vue";
import OrderingTableBoard from "../../views/OrderingTable/Board.vue";
import OrderingTableOrders from "../../views/OrderingTable/Orders/OrderingTableOrders.vue";
import LiveService from "../../views/OrderingTable/LiveService/LiveService.vue";
import ServiceKitchen from "../../views/OrderingTable/LiveService/ServiceKitchen.vue";
import OrderingTableProducts from "../../views/OrderingTable/Products/OrderingTableProducts.vue";
import OrderingTableConfiguration from "../../views/OrderingTable/Settings/OrderingTableConfiguration.vue";
import OrderingTableConfigurationKiosks from "../../views/OrderingTable/Settings/OrderingTableConfigurationKiosks.vue";
import OrderingTableConfigurationSettings from "../../views/OrderingTable/Settings/OrderingTableConfigurationSettings.vue";
import OrderingTableConfigurationPayment from "../../views/OrderingTable/Settings/OrderingTableConfigurationPayment.vue";
import OrderingTableConfigurationTables from "../../views/OrderingTable/Settings/OrderingTableConfigurationTables.vue";
import OrderingTableConfigurationProfitCenter from "../../views/OrderingTable/Settings/OrderingTableConfigurationProfitCenter.vue";
import OrderingTableQRCode from "../../views/OrderingTable/Settings/OrderingTableQRCode.vue";

const routes = [
    {
        path: "/ordering-table",
        name: "ordering_table.home",
        component: OrderingTableList,
    },
    {
        path: "/ordering-table/restaurants/:restaurant_id/board",
        name: "ordering_table.restaurants.board",
        component: OrderingTableBoard,
    },
    {
        path: "/ordering-table/restaurants/:restaurant_id/order",
        name: "ordering_table.restaurants.order",
        component: OrderingTableOrders,
    },
    {
        path: "/ordering-table/restaurants/:restaurant_id/liveservice",
        name: "ordering_table.restaurants.liveservice",
        component: LiveService,
    },
    {
        path: "/ordering-table/restaurants/:restaurant_id/inkitchen",
        name: "ordering_table.restaurants.inkitchen",
        component: ServiceKitchen,
    },
    {
        path: "/ordering-table/restaurants/:restaurant_id/products",
        name: "ordering_table.restaurants.products",
        component: OrderingTableProducts,
    },
    {
        path: "/ordering-table/restaurants/:restaurant_id/configuration",
        name: "ordering_table.restaurants.configuration",
        component: OrderingTableConfiguration,
        children: [
            {
                path: "settings",
                name: "ordering_table.restaurants.configuration.settings",
                component: OrderingTableConfigurationSettings,
            },
            {
                path: "payment",
                name: "ordering_table.restaurants.configuration.payment",
                component: OrderingTableConfigurationPayment,
            },
            {
                path: "tables",
                name: "ordering_table.restaurants.configuration.tables",
                component: OrderingTableConfigurationTables,
            },
            {
                path: "kiosks",
                name: "ordering_table.restaurants.configuration.kiosks",
                component: OrderingTableConfigurationKiosks,
            },
            {
                path: "profit_center",
                name: "ordering_table.restaurants.configuration.profit_center",
                component: OrderingTableConfigurationProfitCenter,
            },
            {
                path: "qr_codes",
                name: "ordering_table.restaurants.configuration.qr_codes",
                component: OrderingTableQRCode,
            },
        ],
    },
];

export default routes;
